/**
 * The "Issued" column on the permits lists.
 *
 * The CRUD's `date` column type renders nothing for a null, which reads as a missing
 * value rather than a meaningful one - and on the review tabs, where nothing is issued
 * yet, that is a whole column of blank cells. A dash says "not yet", which is the
 * actual state.
 *
 * Returns a string because the CRUD renders a custom column through [innerHTML]; the
 * date is formatted here rather than by the date pipe for the same reason. Nothing is
 * user-supplied - the value is a timestamp off the entity.
 */
export function permitIssuedDate(issuedAt?: string | null): string {
    if (!issuedAt) {
        return '<span class="text-body-secondary">-</span>';
    }

    const d = new Date(issuedAt);
    if (Number.isNaN(d.getTime())) {
        return '<span class="text-body-secondary">-</span>';
    }

    // Matches the short format the surrounding date columns use.
    return d.toLocaleDateString('en-AU', { day: 'numeric', month: 'numeric', year: '2-digit' });
}
